import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import './index.less';
import { SvgIcon } from '../SvgIcon';

export interface SearchInputProps {
  defaultValue?: string;
  value?: string;
  placeholder?: string;
  onSearch?: (
    value: string,
    event?:
      | React.ChangeEvent<HTMLInputElement>
      | React.MouseEvent<HTMLElement>
      | React.KeyboardEvent<HTMLInputElement>,
  ) => void;
  onChange?: (
    value: string,
    event?:
      | React.ChangeEvent<HTMLInputElement>
      | React.MouseEvent<HTMLElement>
      | React.KeyboardEvent<HTMLInputElement>,
  ) => void;
}

export function SearchInput(
  props: SearchInputProps &
    Omit<
      React.InputHTMLAttributes<HTMLInputElement>,
      'onChange' | 'value' | 'defaultValue'
    >,
) {
  const {
    defaultValue = '',
    value,
    className,
    onSearch,
    onChange,
    ...otherProps
  } = props;
  const [val, setVal] = useState<string>(defaultValue);
  const [isFocus, setIsFocus] = useState<boolean>(false);
  useEffect(() => {
    if (value !== void 0 && value !== val) {
      setVal(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (onSearch && e.key === 'Enter') {
      onSearch(val, e);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    console.log('searchinput change', val);
    setVal(val);
    if (onChange) {
      onChange(val, e);
    }
  };

  return (
    <span
      className={classnames('search-input-wrapper', className, { isFocus })}
    >
      <input
        {...otherProps}
        className="search-input"
        type="text"
        value={val}
        onKeyDown={handleInputKeyDown}
        onChange={handleInputChange}
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
      />
      <SvgIcon name="search" className="search-input-addon" />
    </span>
  );
}
